import { render } from "./ReportsSubCountyRevenueStreams.vue?vue&type=template&id=22d52006&scoped=true"
import script from "./ReportsSubCountyRevenueStreams.vue?vue&type=script&lang=js"
export * from "./ReportsSubCountyRevenueStreams.vue?vue&type=script&lang=js"

import "./ReportsSubCountyRevenueStreams.vue?vue&type=style&index=0&id=22d52006&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d52006"]])

export default __exports__